import { NavLink } from 'react-router-dom';
import { House, CalendarPlus, UserCircle } from '@phosphor-icons/react';

// Нижняя таб-навигация как на референсе: Главная / Записаться / Профиль.
// Пути от корня сайта: /, /book, /profile.
export function TabBar() {
  const items = [
    { to: '/', end: true, label: 'Главная', Icon: House },
    { to: '/book', end: false, label: 'Записаться', Icon: CalendarPlus },
    { to: '/profile', end: false, label: 'Профиль', Icon: UserCircle }
  ];

  return (
    <nav className="mnc-tabbar" aria-label="Основная навигация">
      {items.map(({ to, end, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => `mnc-tabbar-item${isActive ? ' is-active' : ''}`}
        >
          <Icon weight="duotone" aria-hidden />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
